import { useEffect, useState } from 'react';

import isEqual from 'lodash.isequal';
import usePrevious from '../../hooks/use-previous';

// types
import { FilterNavProps, SchemaFilterType } from './types';
import { ButtonSize } from '../button/types';
import { SelectItemProps } from '../select/types';

// components
import FilterTag from '../tags/filter';
import PseudoButton from '../button/button-pseudo';

// styles
import styles from './tags-list.module.css';

export default function SelectedTags({
  tags,
  filters,
  onFilterChange,
  foundedEntriesForTags,
  lists,
  onClearAutoComplete,
  hiddenFiltersTags,
}: FilterNavProps): React.JSX.Element {
  const [filtersLists, setFiltersList] =
    useState<Record<string, SelectItemProps[]>>();

  const prevFilters = usePrevious(filters);

  const handleRemoveFilterTag = (fieldName: string, value: string) => {
    const nextFilters = { ...filters };

    Object.entries(filters).forEach(([key]) => {
      if (key === fieldName) {
        if (nextFilters[key].type !== SchemaFilterType.DATE_RANGE) {
          nextFilters[key] = {
            value: filters[key]?.value?.filter((item) => item !== value),
            type: nextFilters[key].type,
          };
        } else {
          nextFilters[key] = {
            value: [],
          };
        }
      }
    });

    onFilterChange(nextFilters);
  };

  useEffect(() => {
    if (!filtersLists && lists) {
      setFiltersList(lists);
    } else if (filtersLists && lists && !isEqual(filters, prevFilters)) {
      setFiltersList(lists);
    } else if (filtersLists && lists && !isEqual(lists, filtersLists)) {
      setFiltersList(lists);
    }
  }, [lists, filters, prevFilters, filtersLists]);

  const uniqueTags: string[] = [];

  tags.forEach((tag) => {
    if (!uniqueTags.find((item) => item === tag.key)) {
      uniqueTags.push(tag.key);
    }
  });

  return (
    <div className={styles.filterTags}>
      {tags?.map((filterItem) => {
        let name = filterItem.value;

        if (filtersLists) {
          const currentList = filtersLists[filterItem.key];

          if (currentList) {
            const currentItem = currentList.find(
              (item) => item.value === filterItem.value,
            );

            if (currentItem) {
              name = currentItem.name;

              if (currentItem.suffix) {
                name = `${name} (${currentItem.suffix})`;
              }
            }
          }
        }

        const hidden = Boolean(
          hiddenFiltersTags?.find((tag) =>
            tag === filterItem.key ? styles.hiddenTag : '',
          ),
        );

        return (
          <FilterTag
            key={`${filterItem.key}-${filterItem.value}`}
            type="round"
            title={
              <>
                <span className={styles.label}>{`${
                  filterItem?.label as string
                }: `}</span>
                <span>{name}</span>
              </>
            }
            className={hidden ? styles.hiddenTag : ''}
            onClick={() =>
              handleRemoveFilterTag(filterItem.key, filterItem.value)
            }
          />
        );
      })}
      {(!hiddenFiltersTags?.length ||
        !isEqual(hiddenFiltersTags, uniqueTags)) && (
        <div className={styles.selectedTagsControls}>
          <PseudoButton
            text="Clear all"
            size={ButtonSize.SMALL}
            className={`no-hover ${styles.clearAllButton}`}
            onClick={() => {
              onFilterChange({
                cursor: filters.cursor,
              });

              setFiltersList(undefined);

              if (onClearAutoComplete) {
                onClearAutoComplete();
              }
            }}
            tabIndex={-1}
          />
          <span className={styles.results}>
            {(foundedEntriesForTags as number)
              ? `Found ${foundedEntriesForTags as number} items`
              : 'Items not found'}
          </span>
        </div>
      )}
    </div>
  );
}
